import {Entity, Cartesian3, PropertyBag} from 'cesium';
import {Label as getLabelStyle, Polyline as getStyle, setEntityStyle} from '../renderer';

export default class Polyline extends Entity {
    constructor(options) {
        const {geometry, properties, style, position, label, ...other} = options;

        let props = {
            clampToGround: true,
            properties: new PropertyBag(properties),
            polyline: {
                // fix bug 线会在面的下面
                clampToGround: false,
                positions: Cartesian3.fromDegreesArray(geometry.flat(Infinity)),
                properties: new PropertyBag(properties),
                ...getStyle({...style}),
            },
            ...other,
        };

        // 添加label
        if (label?.text && position) {
            props.position = Cartesian3.fromDegrees(...position)
            props.label = getLabelStyle(label);
        }

        super(props);

        this.geometry = geometry;
    }

    setGeometry(geometry) {
        this.polyline.positions.setValue(Cartesian3.fromDegreesArray(geometry.flat(Infinity)));
    }

    setPosition(position) {
        this.position.setValue(Cartesian3.fromDegrees(...position));
    }

    setProperties(properties) {
        this.properties.setValue(new PropertyBag(properties));
        this.polyline.properties.setValue(new PropertyBag(properties));
    }

    setLabel(label) {
        this.label.setValue(getLabelStyle(label))
    }

    setStyle(style) {
        setEntityStyle(this.polyline, getStyle({...style}));
    }
}
